import { formatMultilineAddress } from '../../multiline-address/multiline-address-preview/multiline-address-preview';
export function formatBookingsAddress(submission, t, language) {
  return formatMultilineAddress(submission, t, language);
}
//# sourceMappingURL=bookings-address-preview.js.map